import { Component } from '@angular/core';

import { ApplicationFacade } from '@ridango/components';
import { AuthService } from '@ridango/core';

@Component({
    selector: 'gl-footer-template-vl',
    templateUrl: './footer-template-vl.component.html'
})
export class FooterTemplateVlComponent {
    assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(private applicationFacade: ApplicationFacade, public ridangoAuth: AuthService) {}
}
